const CURRENT_MARKET = import.meta.env.VITE_ELECTION_MARKET || "au";

const MARKET_PAGES = {
  au: () => import("src/pages/ElectionDashboardAu.vue"),
  nz: () => import("src/pages/ElectionDashboardNz.vue"),
};

export default [
  {
    component: MARKET_PAGES[CURRENT_MARKET],
    path: "/",
  },
];
